import React from 'react';
import { Box, Typography } from '@mui/material';
import { EmployeeSearchProvider } from '../../../../../../../common/EmployeeSearch/contexts/EmployeeSearchProvider';
import EmployeeSearch from '../../../../../../../common/EmployeeSearch';
import { Field } from '../../../../../../../common/Modal';
import { useAbility } from '../../../../../../../../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../../../../../../../../constants/permissions';

const DefaultInternalAssignment = ({
  selectedEmployee,
  setSelectedEmployee,
  selectedManager,
  setSelectedManager,
  setSelectedPositionForRoles
}) => {
  const ability = useAbility();
  const isAdmin = ability.can(ACTIONS.MANAGE, SUBJECTS.ALL);

  const handleEmployeeChange = (employee) => {
    setSelectedEmployee(employee);
    if (employee) {
      setSelectedPositionForRoles(employee.position);
    }
    // Always reset manager when employee changes (including when employee is cleared)
    setSelectedManager(null);
  };

  const handleManagerChange = (manager) => {
    setSelectedManager(manager);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Field>
        <Typography variant="subtitle1" gutterBottom>
          Individual
        </Typography>
        <EmployeeSearchProvider instanceId="employee-selector">
          <EmployeeSearch
            value={selectedEmployee}
            onChange={handleEmployeeChange}
            label=""
            placeholder="Search for an individual..."
            width={400}
            required
          />
        </EmployeeSearchProvider>
      </Field>

      <Field>
        <Typography variant="subtitle1" gutterBottom>
          Representative
        </Typography>
        {isAdmin && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            You are logged in as an admin and can select the same person as both individual and representative.
          </Typography>
        )}
        <EmployeeSearchProvider key={selectedEmployee?.id || 'no-employee'} instanceId="manager-selector">
          <EmployeeSearch
            value={selectedManager}
            onChange={handleManagerChange}
            label=""
            placeholder={selectedEmployee ? "Search for a representative..." : "Select an individual first"}
            disabledEmployeeIds={!isAdmin && selectedEmployee ? [selectedEmployee.id] : []}
            width={400}
            required
            disabled={!selectedEmployee}
            />
          </EmployeeSearchProvider>
      </Field>
    </Box>
  );
};

export default DefaultInternalAssignment;